// src/components/store/sections/faqs/FaqV73BubbleqaSlateGold.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV73BubbleqaSlateGold(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={73}
      archKey="bubble_qa"
      archLabel="Chat Bubble Q&A"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
